import { InteractionStatus } from "@azure/msal-browser";
import { useMsal } from "@azure/msal-react"
import { useEffect, } from "react";
import { setMsalInstance } from "../utils/fetch";

// const BASE_URL = process.env.REACT_APP_BASE_URL;
export const AuthRedirect = ({ children }) => {
  const { instance, accounts, inProgress } = useMsal();
  // const [menuItems, setMenuItems] = useState([]);
  // const [loading, setLoading] = useState(true);


  // const menuItemsMapping = {
  //   ROLE_ANONYMOUS: [
  //     { id: 1, path: "/login", title: "Login", label: "Login" },
  //     {
  //       id: 2,
  //       path: "/authorize",
  //       title: "Authorize",
  //       label: "Authorize",
  //       icon: <AnnouncementOutlinedIcon />,
  //     },
  //   ]
  // }

  useEffect(() => {
    if (inProgress === InteractionStatus.None) {
      setMsalInstance(instance);
      instance
        ?.handleRedirectPromise()
        .then((response) => {
          if (response) {
            processLogin(response);
          } else if (accounts?.length === 0) {
            handleLogin();
          }
        })
        .catch((error) => console.log("Error during redirect:", error));
    }

    const handleLogin = () => {
      const loginRequest = {
        scopes: [process.env.REACT_APP_CLIENT_ID + "/.default"],
      };
      instance?.loginRedirect(loginRequest);
    };

    const processLogin = async (response) => {
      if (!response?.accessToken) return;

      localStorage.setItem("isLoggedIn", "true");
      // await getUserDetails();
    };

  }, [instance, accounts, inProgress]);



  // const rolePriority = [
  //   "Admin",
  //   "ROLE_ANONYMOUS",
  // ];

  // async function getUserDetails() {
  //   try {
  //     const userDetails = await fetchUserDetails();

  //     const roleUser = userDetails.roles || [];
  //     const isAnonymous = roleUser.includes("ROLE_ANONYMOUS");
  //     const isUserNull = !userDetails.user;

  //     // Redirect Anonymous or Null Users
  //     if (isAnonymous || isUserNull) {
  //       setMenuItems(menuItemsMapping["ROLE_ANONYMOUS"]);
  //       setLoading(false);
  //       navigate("/authorize");
  //       return;
  //     }

  //     // Dispatch user data to Redux or context
  //     dispatch(setEmail(userDetails.user.emailId));
  //     dispatch(setRoles(userDetails.roles));
  //     dispatch(setUserData(userDetails.user));
  //     const emailId = userDetails.user.emailId;

  //     // Map roles to menu items and deduplicate
  //     const menuItems = getMenuItems(roleUser);
  //     setMenuItems(menuItems);

  //     setLoading(false);

  //     // Get valid paths from menu items
  //     const validPaths = menuItems.map((item) => item.path);

  //     // Determine the highest-priority role
  //     const highestPriorityRole =
  //       rolePriority.find((role) => roleUser.includes(role)) || "Default";

  //     // Role-based navigation using switch
  //     switch (highestPriorityRole) {

  //       case "Admin":
  //         // Admin users go to manage-users
  //         if (location.pathname !== "/manage-users") {
  //           navigate("/manage-users");
  //         }
  //         break;

  //       case "ROLE_ANONYMOUS":
  //         // Unauthorized users should always go to `/authorize`
  //         navigate("/authorize");
  //         break;

  //       default:
  //         // If no valid role, redirect to default fallback
  //         navigate("/dashboard");
  //     }
  //   } catch (error) {
  //     console.error("Error fetching user details:", error);
  //   }
  // }

  // const fetchUserDetails = async () => {
  //   try {
  //     const response = await ApiService.get(`${BASE_URL}user/details`);
  //     return response.data;
  //   } catch (error) {
  //     console.error("Error fetching user details:", error);
  //     // throw error;
  //   }
  // };

  // const handleLogout = () => {
  //   localStorage.clear();
  //   instance.logoutRedirect({
  //     postLogoutRedirectUri: process.env.REACT_APP_URL,
  //   });
  // };

  // const getMenuItems = (roleList) => {
  //   const menuItems = [];
  //   roleList.forEach((role) => {
  //     if (menuItemsMapping[role]) {
  //       menuItems.push(...menuItemsMapping[role]);
  //     }
  //   });
  //   // Remove duplicate menu items based on the path
  //   return [...new Map(menuItems.map((item) => [item.path, item])).values()];
  // };

  return (
    <>
      { children }
    </>
  )

}